module.exports = __webpack_public_path__ + "static/img/join.96e5399.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/join.png
// module id = OJ6q
// module chunks = 24